const findGeoIdFilterTarget = (filterSet
/*: Object*/
, filterTarget) => {
  if (filterSet.target === filterTarget) return filterSet;

  if (filterSet.operator === 'or' || filterSet.operator === 'and') {
    return filterSet.filters.find(f => findGeoIdFilterTarget(f, filterTarget));
  }

  return false;
};

const OPERATIONS = {
  businessId: 'isAnyOf',
  businessOfferIds: 'containsAnyOf'
};

const getGeoIdFilterTarget = (filterSet, filterTarget) => {
  const found = findGeoIdFilterTarget(filterSet, filterTarget);
  if (found) return found;
  const operation = OPERATIONS[filterTarget];
  if (!operation) throw new Error(`Unable to update ${filterTarget}: Unknown filterTarget (${filterTarget})`);
  const newFilter = {
    target: filterTarget,
    operation
  };
  /* eslint-disable no-param-reassign */

  if (!filterSet.operator && !filterSet.filters) {
    filterSet.operator = 'or';
    filterSet.filters = [newFilter];
  } else if (filterSet.operator === 'or') {
    filterSet.filters.push(newFilter);
  } else if (filterSet.operator === 'and') {
    filterSet.operator = 'or';
    const oldFilters = filterSet.filters;
    filterSet.filters = [newFilter, {
      operator: 'and',
      filters: oldFilters
    }];
  }
  /* eslint-enable no-param-reassign */


  return newFilter;
};

const updateGeoIds = (filterSet
/*: Object*/
= {}, filterTarget
/*: string*/
, newGeoIds
/*: Array<GeoId>*/
) => {
  // 2: check for appropriate expression
  const geoIdFilter = getGeoIdFilterTarget(filterSet, filterTarget);
  geoIdFilter.args = newGeoIds;
  return filterSet;
};

module.exports = updateGeoIds;